import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#004c97",
      light: "#4f7cc3",
      dark: "#002868",
    },
    secondary: {
      main: "#ff8f00",
    },
    background: {
      default: "#f4f6f8",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: ["Roboto", "Segoe UI", "sans-serif"].join(","),
    h1: { fontSize: "2.4rem", fontWeight: 600 },
    h2: { fontSize: "1.9rem", fontWeight: 600 },
    h3: { fontSize: "1.6rem", fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
        },
      },
    },
  },
});

export default theme;
